import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";
import { useSettings } from "context/SettingsContext";
import { Formik } from "formik";
import { useEffect, useRef } from "react";
import ETiny from "components/editors/ETiny";
import Editor from "components/editors/Editor";
import conf from "conf/conf";
import {
    getBaseCurrencyPrefix,
    getBaseCurrencySymbol,
    getCurrencyCode,
    getCurrencySymbol,
    getLocalCurrencyPrefix,
} from "utils/helpers/currency/currencyHelpers";

const initValues = {
    amount:0,
    amountRate:0,
    description:''
}

const CardOtherFormik = ({setShowAddFormik, handleAddExpend}) => {

    const { t } = useTranslation(['Objects', 'Rate']);
    const { localSettings } = useSettings();
    const refInputAmount = useRef();
    const rate = localSettings.RATE.current;
    const TinyEditor = (conf.tinyMode ? ETiny : Editor);

    useEffect(()=>{
        if (refInputAmount.current) {
            refInputAmount.current.focus();
            refInputAmount.current.select();
        } 
    },[refInputAmount.current])
 
    return (
        <Formik initialValues={{...initValues}}
            onSubmit={async (values, {setSubmitting}) => {
                if (values.amount > 0) handleAddExpend(values);
                setShowAddFormik(false);
            }}>
        {({handleSubmit, isSubmitting, setFieldValue, values})=>(
            <Form className="px-3" 
                onSubmit={handleSubmit}>
                <h5 className="mb-3">{t('addExpend.btnAddExpend')}</h5>
                <Form.Group className="mb-3">
                    <label className="form-label text-muted w-100 d-flex justify-content-between">
                        {t('addExpend.priceProduct')} {getCurrencySymbol()}
                        <div><span className="fs-10 me-1 text-muted fw-medium">{t('Rate:rateValue')} {getBaseCurrencySymbol()}:</span><span className="fs-12 text-primary">{rate.toFixed(2)} {getCurrencyCode()}</span></div>
                    </label>
                    <NumericFormat  
                        getInputRef={(el)=>{refInputAmount.current=el}}
                        className="form-control object-price"
                        allowNegative={false}
                        prefix={getLocalCurrencyPrefix()}   
                        thousandSeparator=" "
                        decimalSeparator="."
                        allowedDecimalSeparators={['.', ',']}
                        decimalScale={2}
                        allowLeadingZeros={true}
                        value={values.amountRate}
                        required={true}
                        onValueChange={(val)=>{
                            setFieldValue('amount', val.value /  rate)
                            setFieldValue('amountRate', val.value )
                        }}/>
                </Form.Group>
                <Form.Group className="mb-3">
                    <label className="form-label text-muted w-100 d-flex justify-content-between">
                        {t('addExpend.priceProduct')} {getBaseCurrencySymbol()} </label>
                    <NumericFormat  
                        readOnly={true}
                        className="form-control object-price"
                        allowNegative={false}
                        prefix={getBaseCurrencyPrefix()}   
                        thousandSeparator=" "
                        decimalSeparator="."
                        allowedDecimalSeparators={['.', ',']}
                        decimalScale={2}
                        allowLeadingZeros={true}
                        value={values.amount}
                        required={true}
                        onValueChange={(val)=>{
                            setFieldValue('amount', val.value)
                        }}/>
                </Form.Group>   

                <label className="form-label text-muted w-100 d-flex justify-content-between">
                    {t('addService.labelDescription')}</label>
                <TinyEditor 
                    value={values?.description||''}
                    onChange={(newValue)=>{
                        setFieldValue('description', newValue)
                }}/>


                <div className="text-end py-4">
                    <Button className="me-2"
                        onClick={()=>setShowAddFormik(false)}
                        size="sm"
                        variant="secondary">{t('common:buttons.cancel')}</Button>                    
                    <Button  
                        type="submit"
                        size="sm"
                        disabled={values.amount==0}
                        variant="primary">{t('common:buttons.save')}</Button>
                </div>
            </Form>)}

        </Formik>)
}

export default CardOtherFormik;